import React, {useState, useRef, useLayoutEffect, useEffect} from 'react';

// Hilfsfunktion zur Berechnung, welcher Text am besten passt
// Der "beste" Text ist der längste, dessen Breite die Containerbreite nicht überschreitet.
const findBestFitText = (texts, containerWidth, fontStyles) => {
    if (containerWidth === 0) {
        return texts[0] || ''; // Fallback, falls die Breite noch 0 ist
    }

    // Ein Canvas-Element verwenden, um die Textbreite zu messen,
    // da es effizienter ist als das DOM für viele Messungen.
    // Das Canvas-Element muss dieselben Schriftstil-Eigenschaften (fontStyles) verwenden.
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    // Setze die Schriftart, die für die Messung verwendet werden soll.
    // Dies sollte mit den tatsächlichen CSS-Styles des gerenderten Textes übereinstimmen.
    // Die fontStyles müssen als CSS-Font-String vorliegen (z.B. "16px Arial").
    context.font = fontStyles;

    let bestText = texts[0] || '';
    let bestWidth = 0;

    texts.forEach(text => {
        const textMetrics = context.measureText(text);
        const textWidth = textMetrics.width;

        // Kriterium: Der Text muss in den Container passen (einzeilig) UND
        // er muss breiter sein als der bisher beste gefundene Text.
        if (textWidth <= containerWidth && textWidth > bestWidth) {
            bestWidth = textWidth;
            bestText = text;
        }
    });

    // Wenn kein Text passt, wird der ursprüngliche erste Text zurückgegeben.
    // Man könnte auch eine leere Zeichenkette oder einen Indikator zurückgeben.
    return bestText;
};

// **WICHTIG:** Die `fontStyles` müssen als ein String im CSS-Font-Format
// (z.B. "bold 16px Arial") an die Komponente übergeben werden,
// um eine genaue Messung mit dem Canvas zu gewährleisten.
const defaultFontStyles = '16px sans-serif';

export function BestFitText({ texts, fontStyles = defaultFontStyles }) {
    const containerRef = useRef(null);
    const [bestText, setBestText] = useState(texts[0] || '');
    const [containerWidth, setContainerWidth] = useState(0);

    // useLayoutEffect wird verwendet, um Messungen durchzuführen, bevor der Browser neu zeichnet.
    useLayoutEffect(() => {
        if (containerRef.current) {
            // 1. Containerbreite ermitteln (Flex-Bereich)
            const newWidth = containerRef.current.getBoundingClientRect().width;
            setContainerWidth(newWidth);
        }
    }, [texts]); // Abhängigkeit von texts, um Messung bei Änderung der Liste erneut durchzuführen

    // Führe die Logik zur Textauswahl aus, wenn die Breite bekannt ist
    useEffect(() => {
        if (containerWidth > 0 && texts.length > 0) {
            const selectedText = findBestFitText(texts, containerWidth, fontStyles);
            setBestText(selectedText);
        }
    }, [containerWidth, texts, fontStyles]);


    return (
        <div ref={containerRef} className="text-container" style={{ flex: 1, overflow: 'hidden' }}>

                {bestText}
        </div>
    );
}